export default __webpack_public_path__ + "static/media/triber-gallery-6.b13e7c8d.jpg";